import React from "react"

import { sanitizeHtml } from "@/lib/sanitizeHtml"
import { cn, parseSimpleString } from "@/lib/utils"
import { Link, Typography, type TLinkProps } from "@/components/ui/atoms"

// PageTitle's CTA buttons are always simple text labels (used as the
// analytics `chapters` entry too), unlike Link's general ReactNode children.
type TPageTitleButton = Omit<TLinkProps, "chapters" | "children"> & {
  children: string
}

type TPageTitleProps = {
  title: string
  subtitle?: string
  button?: TPageTitleButton
  buttonSecondary?: TPageTitleButton
  className?: string
}

const PageTitle = ({
  title,
  subtitle,
  button,
  buttonSecondary,
  className,
}: TPageTitleProps) => {
  /*
      throw error if no title is used in the component
    */
  if (!title) {
    throw new Error("Title must not be empty.")
  }
  return (
    <div className={cn("bg-neutral-200 py-15", className)}>
      <div className="container">
        <div
          className="heading-xl mb-9 text-center"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(title) }}
        />
        {subtitle ? (
          <Typography
            variant="paragraphL"
            className="mb-9 text-center lg:mx-17"
          >
            {subtitle}
          </Typography>
        ) : null}

        {button ? (
          <div className="flex flex-col flex-wrap items-center md:flex-row md:justify-center">
            <Link
              chapters={[parseSimpleString(title), button.children]}
              className="my-3"
              href={button.href}
              variant={button.variant}
              iconLeft={button.iconLeft}
            >
              {button.children}
            </Link>
            {buttonSecondary ? (
              <Link
                chapters={[parseSimpleString(title), buttonSecondary.children]}
                className="text-center md:mx-5 md:my-3"
                href={buttonSecondary.href}
                variant={buttonSecondary.variant}
                iconLeft={buttonSecondary.iconLeft}
              >
                {buttonSecondary.children}
              </Link>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  )
}
export { PageTitle, type TPageTitleProps }
